import script from "./RcDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RcDialog.vue?vue&type=script&setup=true&lang=js"

import "./RcDialog.vue?vue&type=style&index=0&id=0945795c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0945795c"]])

export default __exports__